<template>
    <div>
        <static-loading-indicator-icon :with-card="true"/>
        <div class="card shadow-sm" v-if="!$store.getters.isExecutingRequest">
            <div class="card-body">
                <h5 class="card-title">
                    {{ $t('pages.subscription.resume.title') }}
                </h5>

                <p v-html="$t('pages.subscription.resume.want_to_resume')"></p>
                <p v-html="$t('pages.subscription.resume.will_renew', {date: $date(this.willBeRenewedAt).format('DD.MM.YYYY'), price: renewalPrice + '€'})"></p>

                <button class="btn btn-outline-dark" @click="resumeSubscription">
                    {{ $t('pages.subscription.resume.confirm') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../../../Includes/PageHeader";
import StaticLoadingIndicatorIcon from "../../../../Includes/StaticLoadingIndicatorIcon";
import SubscriptionRepository from "../../../../../repositories/Subscription/SubscriptionRepository";
export default {
name: "SubscriptionResume",
    components: {StaticLoadingIndicatorIcon, PageHeader},
    data: () => ({
        isSubscribed: false,
        onGracePeriod: true,
        willBeRenewedAt: '',
        monthsPaid: 0,
        renewalPrice: '',
    }),
    mounted() {
        this.getSubscriptionStatus();
    },
    methods: {
        resumeSubscription() {
            SubscriptionRepository
                .resumeSubscription()
                .then((res) => {
                    this.$snotify.success(this.$t('pages.subscription.resume.resumed', {date: this.$date(this.willBeRenewedAt).format('DD.MM.YYYY')}));
                    this.$router.push({name: 'subscription'});
                });
        },
        getSubscriptionStatus() {
            SubscriptionRepository
                .getStatus()
                .then((res) => {
                    this.isSubscribed = res.data.active;
                    this.onGracePeriod = res.data.on_grace_period;
                    this.willBeRenewedAt = res.data.will_be_renewed_at;
                    this.monthsPaid = res.data.months_paid;
                    this.renewalPrice = res.data.renewal_price;

                    if(!this.onGracePeriod) {
                        this.$router.push({name: 'subscription'});
                    }
                });
        },
    }
}
</script>

<style scoped>

</style>
